import React from 'react'

import { Button } from '../Button/Button';
import './Footer.css';

function Footer() {
    return (
        <div className='footer-container'>
            <section className='footer-contribution'>
                <h1> CULTAGE </h1>
                <h2> Sarawak Cultural Heritage Information System</h2>
                <p className= "footer-contribution-heading"> 
                Join us in the effort of digitizing Sarawak's cultural heritage
                </p>  
        
                <div className='input-areas'> 
                <form> 
                    
                        <div> <Button buttonStyle='btn--outline'> CONTRIBUTE 

                        </Button>
                        </div>
                </form>
                </div> 
            </section> 
            <div className='footer-links'> 
            <section className='social-media'>
                <div className='social-media-wrap'> 
                   
                    
                </div>
            </section>
            
            </div>
            
        </div>
    );
}

export default Footer
